import React from 'react';

import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import { LoadablePaint } from '@confluence/loadable';

const SpaceSettingsRelatedPagesRouteComponent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceSettingsRelatedPagesRouteComponent" */ './SpaceSettingsRelatedPagesRouteComponent'
			)
		).SpaceSettingsRelatedPagesRouteComponent,
});

export const SpaceSettingsRelatedPagesRoute = ({ params: { spaceKey } }) => (
	<SpaceSettingsRelatedPagesRouteComponent spaceKey={spaceKey} />
);

SpaceSettingsRelatedPagesRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } },
	isNav4Enabled,
) => ({
	Screen: {
		screenEvent: { name: 'spaceSettingsRelatedPages', id: spaceKey },
		pageState: { spaceKey, routeName: name },
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
		disableMinWidth: true,
	},
});
